import {Card, FormControl, FormField, Radio, Separator} from 'platform/components';
import {Grid, Heading, HStack, Show, VStack} from 'platform/foundation';

import {UseFormReturn} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {DiscountSectionFormType} from '../types/discountSectionSchema';
import {MaterialDiscountOption} from '../types/materialDiscountOption';

const MATERIAL_OPTIONS = [
  {
    label: i18n.t('entity.order.labels.discountOnSalePrice'),
    value: MaterialDiscountOption.DiscountOnSalePrice,
  },
  {
    label: i18n.t('entity.order.labels.marginToPurchasePrice'),
    value: MaterialDiscountOption.MarginToPurchasePrice,
  },
];

interface DiscountOnMaterialCardProps extends RequiredTestIdProps {
  control: FormControl<DiscountSectionFormType>;
  formApi: UseFormReturn<DiscountSectionFormType>;
  isReadOnly?: boolean;
}

export function DiscountOnMaterialCard(props: DiscountOnMaterialCardProps) {
  const isExpanded = props.formApi.watch('isMaterialExpanded');
  const selectedOption = props.formApi.watch('selectedMaterialOption');

  return (
    <Card variant="inlineGrey">
      <HStack align="center" spacing={3}>
        <FormField
          control={props.control}
          name="isMaterialExpanded"
          type="switch"
          isDisabled={props.isReadOnly}
          data-testid={suffixTestId('expand-switch', props)}
        />
        <Heading size={4}>{i18n.t('entity.order.labels.discountOnMaterial')}</Heading>
      </HStack>
      <Show when={isExpanded}>
        <Separator />
        <VStack spacing={4}>
          <Radio
            options={MATERIAL_OPTIONS}
            value={selectedOption}
            onChange={(value) =>
              props.formApi.setValue('selectedMaterialOption', value as MaterialDiscountOption)
            }
            isDisabled={props.isReadOnly}
            data-testid={suffixTestId('material-options', props)}
          />
          <Grid columns={4} spacing={4}>
            <Show when={selectedOption === MaterialDiscountOption.DiscountOnSalePrice}>
              <FormField
                control={props.control}
                name="material.percentDiscount.discountOnSalePriceRate"
                type="number"
                label={i18n.t('entity.order.labels.percentage')}
                suffix="%"
                decimalPlaces={2}
                isDisabled={props.isReadOnly}
                data-testid={suffixTestId('discount-on-sale-price', props)}
              />
            </Show>
            <Show when={selectedOption === MaterialDiscountOption.MarginToPurchasePrice}>
              <FormField
                control={props.control}
                name="material.percentDiscount.discountMarginToPurchasePriceRate"
                type="number"
                label={i18n.t('entity.order.labels.percentage')}
                suffix="%"
                decimalPlaces={2}
                isDisabled={props.isReadOnly}
                data-testid={suffixTestId('margin-to-purchase-price', props)}
              />
            </Show>
          </Grid>
        </VStack>
      </Show>
    </Card>
  );
}
